import { createApi } from "@reduxjs/toolkit/query/react"
import { ValidationErrorResponse } from "@custom-types/common"
import { DivisionDto, DivisionsDto, GetDivisionsQueryParams } from "@custom-types/division"
import { authQuery } from "./authQuery"

export const divisionsApi = createApi({
  reducerPath: "divisionsApi",
  baseQuery: authQuery,
  endpoints: (builder) => ({
    getDivisions: builder.query<DivisionsDto, GetDivisionsQueryParams>({
      query: ({ organisation_key = undefined }) => ({
        url: "/divisions",
        params: {
          organisation_key: organisation_key,
        },
      }),
    }),
    postDivision: builder.mutation<DivisionDto | ValidationErrorResponse | string, DivisionDto>({
      query: (payload) => ({
        url: "/divisions",
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    putDivision: builder.mutation<DivisionDto | ValidationErrorResponse | string, DivisionDto>({
      query: (payload) => ({
        url: `/divisions/${payload.key}--${payload.organisation_key}`,
        method: "PUT",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    deleteDivision: builder.mutation<string, { divisionKey: string; organisationKey: string }>({
      query: ({ divisionKey, organisationKey }) => ({
        url: `/divisions/${divisionKey}--${organisationKey}`,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useGetDivisionsQuery,
  usePostDivisionMutation,
  usePutDivisionMutation,
  useDeleteDivisionMutation,
} = divisionsApi
